import { Dispatch, SetStateAction } from 'react'
import { ValidationError } from 'yup'
import { getErrorsForFields } from './getErrorsForField'
import { SubmitFailedEventDetail } from '../../../../../../MyStichtingOpenHelpers/src/static'

/**
 * @description
 * takes the Event object from a SUBMIT_FAILED event and repopulates the errors array
 * if there are errors related to this fieldName
 * @memberof ValidationMessage
 * */
export const onSubmitFailed = (
    event: CustomEvent<SubmitFailedEventDetail>,
    formId: string,
    fieldNames: string | string[],
    setValidationErrors: Dispatch<SetStateAction<ValidationError[]>>,
) => {
    if (formId !== event.detail.formId) {
        return
    }
    const errors = getErrorsForFields(event.detail.validationErrors, fieldNames)
    setValidationErrors(errors)
}
